import * as actionTypes from './actionTypes';
import { CASEBODY_TAB_NAMES } from '../../../constants';

export const setAddresses = addresses => ({
  type: actionTypes.SET_ADDRESSES,
  addresses
})

export const setPersons = persons => ({
  type: actionTypes.SET_PERSONS,
  persons
})

export const setCurrentCustomerDetails = customerData => ({
  type: actionTypes.SET_CURRENT_CUSTOMER_DETAILS,
  customerData
})

export const resetCurrentCustomerDetails = () => ({
  type: actionTypes.RESET_CURRENT_CUSTOMER_DETAILS
})

export const setCurrentCustomerDetailsStatus = statuses => ({
  type: actionTypes.SET_CURRENT_CUSTOMER_DETAILS_STATUSES,
  statuses
})

export const setProductsDetails = productsDetailsdata => ({
  type: actionTypes.SET_PRODUCTS_DETAILS,
  productsDetailsdata
})

export const setCurrentProductAccount = productAccountData => ({
  type: actionTypes.SET_CURRENT_PRODUCT_ACCOUNT,
  productAccountData
})

export const resetCurrentProductAccount = () => ({
  type: actionTypes.RESET_CURRENT_PRODUCT_ACCOUNT
})

export const setCurrentProductAccountEchannels = echannels => ({
  type: actionTypes.SET_CURRENT_PRODUCT_ACCOUNT_ECHANNELS,
  echannels
})

export const setCurrentProductAccountStatuses = statuses => ({
  type: actionTypes.SET_CURRENT_PRODUCT_ACCOUNT_STATUSES,
  statuses
})

export const setCurrentProductEchannel = productEchannelData => ({
  type: actionTypes.SET_CURRENT_PRODUCT_ECHANNEL,
  productEchannelData
})

export const setCurrentProductAllAccounts = productEchannelAccountData => ({
  type: actionTypes.SET_CURRENT_PRODUCT_ACCOUNTS,
  productEchannelAccountData
})

export const setExistingEntityData = existingEntityData => ({
  type: actionTypes.SET_EXISTING_ENTITY_DATA,
  existingEntityData
})

export const setCurrentProductEchannelStatuses = statuses => ({
  type: actionTypes.SET_CURRENT_PRODUCT_ECHANNEL_STATUSES,
  statuses
})

export const setCurrentProductGlsCashCon = productGlsCashConData => ({
  type: actionTypes.SET_CURRENT_PRODUCT_GLS_CASH_CON,
  productGlsCashConData
})

export const setCurrentProductGlsCashConStatuses = statuses => ({
  type: actionTypes.SET_CURRENT_PRODUCT_GLS_CASH_CON_STATUSES,
  statuses
})

export const setCrossBorder = CrossBorderDtata => ({
  type: actionTypes.SET_CORSS_BORDER_STATUS,
  CrossBorderDtata
})

export const setActivationTabData = activationdata => ({
  type: actionTypes.SET_ACTIVATION_TAB_DATA,
  activationdata
})

export const enableCaseBodyFooterBtn = btnName => ({
  type: actionTypes.ENABLE_CASE_BODY_FOOTER_BTN,
  btnName
})

export const disableCaseBodyFooterBtn = btnName => ({
  type: actionTypes.DISABLE_CASE_BODY_FOOTER_BTN,
  btnName
})

export const enableAllCaseBodyFooterBtns = () => ({
  type: actionTypes.ENABLE_ALL_CASE_BODY_FOOTER_BTNS
})

export const disableAllCaseBodyFooterBtns = () => ({
  type: actionTypes.DISABLE_ALL_CASE_BODY_FOOTER_BTNS
})

export const showPreviewAndGenerateDocBtns = () => ({
  type: actionTypes.SHOW_PREVIEW_AND_GENERATEDOC_BTNS
})

export const hidePreviewAndGenerateDocBtns = () => ({
  type: actionTypes.HIDE_PREVIEW_AND_GENERATEDOC_BTNS
})

export const setCurrentActiveTab = (activeTabId) => ({
  type: actionTypes.SET_CURRENT_ACTIVE_TAB,
  activeTabId
})

export const setLandingActiveTab = (activeTabId) => ({
  type: actionTypes.SET_LANDING_ACTIVE_TAB,
  activeTabId
})

export const setTabsStatus = (tabName, isComplete) => ({
  type: actionTypes.SET_TABS_STATUS,
  tabName,
  isComplete
})

export const setTabsStatuses = tabStatuses => ({
  type: actionTypes.SET_TABS_STATUSES,
  tabStatuses
})

export const setGenrateDoc = (generatedata) => ({
  type: actionTypes.SET_GENERATE_DOC,
  generatedata
})

export const setGenrateSsf = (generateSsfdata) => ({
  type: actionTypes.SET_GENERATE_SSF,
  generateSsfdata
})

export const setGslAgent = (glsAgentData) => ({
  type: actionTypes.SET_GLS_AGENT,
  glsAgentData
})

export const enableTab = tabName => {
  // picking correct tabname based on tab number
  if (!isNaN(tabName)) {
    tabName = CASEBODY_TAB_NAMES[parseInt(tabName, 10)];
  }
  return {
    type: actionTypes.ENABLE_TAB,
    tabName
  }
}

export const enableTabsTillIndex = tabIndex => {
  let tabNames = [];
  // picking correct tabname based on tab number
  for (var i = tabIndex; i >= 0; i--) {
    tabNames.push(CASEBODY_TAB_NAMES[i]);
  }
  return {
    type: actionTypes.ENABLE_TABS,
    tabNames
  }
}

export function enableTabs(...tabNames) {
  // picking correct tabname based on tab number
  let _tabNames = tabNames.reduce((_tabNames, tabName, index) => {
    _tabNames[index] = isNaN(tabName) ? tabName : CASEBODY_TAB_NAMES[parseInt(tabName, 10)];
    return _tabNames;
  }, []);
  return {
    type: actionTypes.ENABLE_TABS,
    tabNames: _tabNames
  }
}

export const disableTab = tabName => {
  // picking correct tabname based on tab number
  if (!isNaN(tabName)) {
    tabName = CASEBODY_TAB_NAMES[parseInt(tabName, 10)];
  }
  return {
    type: actionTypes.DISABLE_TAB,
    tabName
  }
}
export function disableTabs(...tabNames) {
  // picking correct tabname based on tab number
  let _tabNames = tabNames.reduce((_tabNames, tabName, index) => {
    _tabNames[index] = isNaN(tabName) ? tabName : CASEBODY_TAB_NAMES[parseInt(tabName, 10)];
    return _tabNames;
  }, []);
  return {
    type: actionTypes.DISABLE_TABS,
    tabNames: _tabNames
  }
}

export const enableCaseBodyFooterSubmitBtn = btnName => ({
  type: actionTypes.ENABLE_CASE_BODY_FOOTER_SUBMIT_BTN,
  btnName
})

export const newEntities = entities => ({
  type: actionTypes.NEW_ENTITIES,
  entities
})

export const setCaseOwner = caseOwnerDetails => ({
  type: actionTypes.SET_CASE_OWNER,
  caseOwnerDetails
})

export const oldEntities = entities => ({
  type: actionTypes.OLD_ENTITIES,
  entities
})

export const setCustomerDetailActiveTabIndex = index => ({
  type: actionTypes.SET_CUSTOMER_DETAIL_ACTIVE_TAB_INDEX,
  index
})

export const reSetCustomerDetailActiveTabIndex = () => ({
  type: actionTypes.RESET_CUSTOMER_DETAIL_ACTIVE_TAB_INDEX
})

export const setNewAccountActiveTabIndex = index => ({
  type: actionTypes.SET_NEW_ACCOUNT_ACTIVE_TAB_INDEX,
  index
})

export const reSetNewAccountActiveTabIndex = () => ({
  type: actionTypes.RESET_NEW_ACCOUNT_ACTIVE_TAB_INDEX
})

export const setEChannelActiveTabIndex = index => ({
  type: actionTypes.SET_E_CHANNEL_ACTIVE_TAB_INDEX,
  index
})

export const reSetEChannelActiveTabIndex = index => ({
  type: actionTypes.RESET_E_CHANNEL_ACTIVE_TAB_INDEX
})

export const setCountryFormActiveTabIndex = index => ({
  type: actionTypes.SET_COUNTRY_FORM_TAB_INDEX,
  index
})

export const reSetCountryFormActiveTabIndex = () => ({
  type: actionTypes.RESET_COUNTRY_FORM_TAB_INDEX
})

export const getDarkTitleBarFlag = (flag) => ({
  type: actionTypes.SET_DARK_FLAG,
  flag
})

export const setNewSweepActiveTabIndex = index => ({
  type: actionTypes.SET_NEW_SWEEP_ACTIVE_TAB_INDEX,
  index
})

export const reSetNewSweepActiveTabIndex = () => ({
  type: actionTypes.RESET_NEW_SWEEP_ACTIVE_TAB_INDEX
})

export const setCaptureProductAch = data => ({
  type: actionTypes.SET_CURRENT_PRODUCT_ACH,
  data
})

export const setOtherAccountAch = accounts => ({
  type: actionTypes.SET_OTHER_ACCOUNT_ACH,
  accounts
})

export const resetCurrentProductAch = () => ({
  type: actionTypes.RESET_CURRENT_ACH_PRODUCT
})

export const setAchCreditActiveTabIndex = index => ({
  type: actionTypes.SET_ACH_CREDIT_ACTIVE_TAB_INDEX,
  index
})

export const resetAchCreditActiveTabIndex = () => ({
  type: actionTypes.RESET_ACH_CREDIT_ACTIVE_TAB_INDEX
})

export const setCaptureProductCorporateCard = data => ({
  type: actionTypes.SET_PRODUCT_CORPORATECARD,
  data
})

export const resetcurrentProductCorporateCard = () => ({
  type: actionTypes.RESET_CORPORATECARD_PRODUCT
})

export const setCorporateCardActiveTabIndex = index => ({
  type: actionTypes.SET_CORPORATECARD_ACTIVE_TAB_INDEX,
  index
})

export const resetCorporateCardActiveTabIndex = () => ({
  type: actionTypes.RESET_CORPORATECARD_ACTIVE_TAB_INDEX
})

export const setCaptureProductCashFlowForecasting = data => ({
  type: actionTypes.SET_PRODUCT_CASHFLOWFORECASTING,
  data
})

export const resetCurrentProductCashFlowForecasting = () => ({
  type: actionTypes.RESET_CASHFLOWFORECASTING_PRODUCT
})

export const setCashFlowForecastingActiveTabIndex = index => ({
  type: actionTypes.SET_CASHFLOWFORECASTING_ACTIVE_TAB_INDEX,
  index
})

export const resetCashFlowForecastingActiveTabIndex = () => ({
  type: actionTypes.RESET_CASHFLOWFORECASTING_ACTIVE_TAB_INDEX
})

export const setCurrentDropDownSelect = data => ({
  type: actionTypes.SET_CURRENT_DROPDOWNSELECT,
  data
})

export const resetCurrentDropDownSelect = () => ({
  type: actionTypes.RESET_CURRENT_DROPDOWNSELECT,

})


// WEBPACK FOOTER //
// ./src/components/CaseBody/actions/actionCreator.js